<template>
  <div class="bgwrap" @click="closeMask">
    <div class="left_nav" @click.stop="a = 1">
      <div class="search_box" @click="$router.push('recente')">
        <div class="search_title">
          {{ $t("搜索") }}
        </div>
        <div class="search_img">
          <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
            <path id="ugU8fLxr-comm_icon_ss"
              d="M1610.592-172.388l-6.849-6.64a9.445,9.445,0,0,1-5.266,1.584,9.427,9.427,0,0,1-6.659-2.718,9.154,9.154,0,0,1-2.757-6.561,9.158,9.158,0,0,1,2.757-6.561,9.429,9.429,0,0,1,6.659-2.718,9.427,9.427,0,0,1,6.658,2.718,9.152,9.152,0,0,1,2.758,6.561,9.12,9.12,0,0,1-2,5.715l6.692,6.49a1.438,1.438,0,0,1,.081,2.051,1.476,1.476,0,0,1-1.08.466A1.475,1.475,0,0,1,1610.592-172.388Zm-18.7-14.335a6.546,6.546,0,0,0,6.588,6.488,6.617,6.617,0,0,0,4.056-1.38,1.457,1.457,0,0,1,.234-.333,1.467,1.467,0,0,1,.534-.363,6.412,6.412,0,0,0,1.762-4.413,6.545,6.545,0,0,0-6.586-6.488A6.546,6.546,0,0,0,1591.89-186.723Z"
              transform="translate(-1589.062 196.002)" />
          </svg>
        </div>
      </div>
      <!--游戏类型-->
      <div class="game-itmes" v-if="list.case_tpl_id != 'case_5'">
        <div class="game_type">
          <div class="game_item" v-for="(item, index) in list.cate_list" :class="active_menu == index ? 'active' : ''"
            @click="goMenu(index)">
            <!-- <img v-if="active_menu == 0" class="game_img" src="../assets/images/category/HOTa.png">
            <img v-else class="game_img" src="../assets/images/category/HOT.png"> -->
            <img class="game_img" :src="item.image" alt="">
            <div class="game_name">
              {{ item.abbr }}
            </div>
          </div>
        </div>
      </div>

      <!-- MP3播放器-->
      <div class="mp3_item">
        <div class="mp3_player">
          <audio-player ref="audioPlayer" :audio-list="audioList.map((elm) => elm.url)" :before-play="handleBeforePlay"
            :show-progress-bar="false" :show-playback-rate="false" theme-color="#fff0bb" />
          <div class="music_name">
            {{ currentAudioName || audioList[0].name }}
          </div>
        </div>
      </div>
      <div class="game_record" @click="
        jumpRecord
      ">
        <div class="grsvg">
          <!-- <img src="../assets/images/leftNav/record.png" alt="" /> -->
          <!-- <van-icon name="list-switch" /> -->
          <Record />
        </div>
        <div class="grt">
          {{ $t("投注") }}
        </div>
      </div>
      <div class="game_record" @click="
        $router.push('agent');
      $parent.show_left_nav = false;
      ">
        <div class="grsvg">
          <!-- <img src="../assets/images/leftNav/record.png" alt="" /> -->
          <!-- <van-icon name="list-switch" /> -->
          <Agent />
        </div>
        <div class="grt">
          {{ $t("代理人") }}
        </div>
      </div>

      <div class="active_box">
        <div class="top_title">
          {{ $t("晋升") }}
        </div>
        <div class="active_record">
          <div class="active_item acbg1" @click="
            $router.push('/activity?tab=0');
          $parent.show_left_nav = false;
          ">
            {{ $t("活动") }}
          </div>
          <div class="active_item acbg2" @click="
            $router.push('/activity?tab=2');
          $parent.show_left_nav = false;
          ">
            VIP
          </div>
          <div class="active_item acbg3" @click="showRedemptionCode()">
            {{ $t("兑换码") }}
          </div>
          <div class="active_item acbg4" @click="
            // $router.push('withdraw');
            $parent.show_left_nav = false;
          ">
            {{ $t("待办") }}
          </div>
          <div class="active_item acbg5" @click="
            $router.push('/activity?tab=1');
          $parent.show_left_nav = false;
          ">
            {{ $t("推动") }}

          </div>
          <div class="active_item acbg6" @click="
            $router.push('/record');
          $parent.show_left_nav = false;
          ">
            {{ $t("声明") }}
          </div>
          <div class="active_item acbg7" @click="
            $router.push('/activity?tab=5');
          $parent.show_left_nav = false;
          ">
            {{ $t("历史") }}
          </div>
          <!-- <div class="active_item acbg8" @click="
            $router.push('/Turntable');
          $parent.show_left_nav = false;
          ">
            Turntable
          </div> -->
        </div>
      </div>

      <div class="other_list">
        <!-- <a
          href="https://download.10000xbet.com/"
          target="_blank"
          class="other_item"
        >
          <div class="icon-wrap"><van-icon name="down" /></div>
          <div class="other_text">Baixar App</div>
        </a> -->
        <div class="other_item" @click="goSupport">
          <div class="icon-wrap">
            <van-icon name="service-o" />
          </div>
          <div class="other_text">
            {{ $t("支持") }}
          </div>
        </div>
        <div class="other_item" @click="goSupport">
          <div class="icon-wrap">
            <van-icon name="question-o" />
          </div>
          <div class="other_text">
            {{ $t("常问问题") }}
          </div>
        </div>
        <div class="other_item" @click="changeLang">
          <div class="icon-wrap">
            <van-icon name="list-switching" />
          </div>
          <div class="other_text">
            {{ $t("语言") }}
          </div>
        </div>
        <div class="other_item" @click="logout()">
          <div class="icon-wrap">
            <van-icon name="stop-circle-o" />
          </div>
          <div class="other_text">
            {{ $t("退出") }}
          </div>
        </div>
      </div>
      <div class="language-switcher" v-if="langShow">
        <div @click="selectLang(item)" v-for="item in langData"
          :class="defaultLang == item.name ? 'active-lang lang' : 'lang'">{{
            item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Fetch from "../utils/fetch";
import AudioPlayer from "@liripeng/vue-audio-player";
import Record from "./svg/record.vue";
import Agent from "./svg/agent.vue";
import { EventBus } from '../utils/utils.js'
import { Icon, Cell, CellGroup, Collapse, CollapseItem, Popup } from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(Collapse).use(CollapseItem).use(Popup);

export default {
  name: "User",
  components: {
    AudioPlayer,
    Record,
    Agent,
  },
  data() {
    return {
      langData: [],
      currentLocale: this.$i18n.locale,
      activeNames: ["1", "2"],
      langShow: false,
      currentAudioName: "",
      defaultLang: '',
      active_menu: 0,
      list: [],
      audioList: [
        {
          name: "You Spin Me Round",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FYou+Spin+Me+Round.mp3",
        },
        {
          name: "Yesterday",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FYesterday.mp3",
        },
        {
          name: "See You Again",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FWiz+Khalifa+-107.+See+You+Again+ft.+Charlie+Puth+%5BOfficial+Video%5D+Furious+7+Soundtrack.mp3",
        },
        {
          name: "Without You",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FWithout+You.mp3",
        },
        {
          name: "Live It Up",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FWill+Smith-9.Live+It+Up.mp3",
        },
        {
          name: "Waiting for Love",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FWaiting+for+Love.mp3",
        },
        {
          name: "Wait Wait Wait",
          url: "https://company-fj.s3.ap-east-1.amazonaws.com/siteadmin%2Fupload%2Fmusic%2FWait+Wait+Wait.mp3",
        },
      ],
    };
  },
  created() {
  },
  mounted() {
    EventBus.$on('lang-data-ready', data => {
      this.langData = data.language;
      this.audioList = data.music;
      let lang = 'pt';
      if (!localStorage.getItem('X-language')) {
        localStorage.setItem("X-language", lang)
      } else {
        this.defaultLang = localStorage.getItem('X-language');
      }
    })
    EventBus.$on('nav-data-ready', data => {
      this.list = data;
    })
  },
  beforeDestroy() {
    EventBus.$off('api-data-ready')
    EventBus.$off('nav-data-ready')
  },
  methods: {
    changeLang() {
      this.langShow = !this.langShow;
    },
    selectLang(item) {
      if (item.id == this.defaultLang) return;
      this.defaultLang = item.name;
      localStorage.setItem("X-language", item.name);
      window.location.reload();
    },
    goMenu(idx) {
      // this.$parent
      if (this.list.case_tpl_id == 'case_2') {
        if (idx == 1) {
          this.$parent.show_left_nav = false;
          this.$router.push("/recente?gameId=SLOTS&flag=true")
          return
        }
        if (idx == 2) {
          this.$parent.show_left_nav = false;
          this.$router.push("/recente")
          return
        }
        if (idx == 3) {
          this.$parent.show_left_nav = false;
          this.$router.push("/recente?title=Favoritos")
          return
        }
        this.active_menu = idx;
        if (this.$router.currentRoute.name != "index") {
          this.$router.push({
            path: "index",
            params: {
              nav: idx,
            },
          });
        } else {
          this.$bus.$emit("send2index", idx);
          this.$parent.show_left_nav = false;
        }
      } else {
        this.active_menu = idx;
        EventBus.$emit('leftNavChange', this.list.cate_list[idx]);
      }

    },
    onOpen(event) {
      Toast(`展开: ${event.detail}`);
    },
    onClose(event) {
      Toast(`关闭: ${event.detail}`);
    },
    // 播放前做的事
    handleBeforePlay(next) {
      // 这里可以做一些事情...
      this.currentAudioName =
        this.audioList[this.$refs.audioPlayer.currentPlayIndex].name;
      next(); // 开始播放
    },

    goSupport() {
      this.$message.success({
        title: this.$t('客户服务'),
        message: this.$t('团队每周 7 天、每天 24 小时为您服务'),
      });
      setTimeout(() => {
        this.$parent.isShowSupport = true;
        EventBus.$emit('supTabChange', 0);
      }, 500)
    },
    logout() {
      Fetch("/user/logout").then((r) => {
        if (r.code == 1) {
          localStorage.removeItem("user_balance");
          this.$router.go(0);
          localStorage.removeItem("token");
        }
      });
    },
    showRedemptionCode() {
      this.$parent.show_left_nav = false;
      this.$bus.$emit("isShowRedemptionCode", true);
    },
    closeMask() {
      this.$parent.nowScrollTop = document.getElementsByTagName('html')[0].scrollTop || document.body.scrollTop
      setTimeout(() => {
        this.$parent.show_left_nav = !this.$parent.show_left_nav;
        this.langShow = false;
      }, 100);
    },
    jumpRecord() {
      this.$router.push({ path: "/report/report", query: { tab: 1 } })
      this.$parent.show_left_nav = false;
    }
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/variables.less";

.other_item {
  width: 80%;
  display: flex;
  margin-bottom: 0.3rem;
}

.icon-wrap {
  height: 0.5rem;
  width: 0.5rem;
  line-height: 0.5em;
  background: @textcolor3;
  border-radius: 50%;
  text-align: center;
  font-weight: 700;
  color: #111;
  font-size: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_box {
  width: 93%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 14px 6px 6px;
  background-color: @third-color;
  margin: 0 auto;
  border-radius: .2rem;
  color: @textcolor2;
  box-sizing: border-box;
  font-size: 11px;

  .search_img {
    font-size: 14px;
    color: @anttextcolor;
  }

  // margin-top: .2rem;
}

.other_text {
  height: 0.5rem;
  line-height: 0.5rem;
  text-indent: 0.2rem;
  color: @popupTextColor;
  font-size: 0.28rem;
}

.mp3_player {
  // width: 94%;
  background: @third-color;
  margin: 0 auto 0.15rem auto;
  //overflow: hidden;
  border-radius: 0.2rem;
  padding: 0.1rem;
  box-sizing: border-box;
}

.music_name {
  text-align: center;
  color: @popupTextColor;
  // font-weight: bold;
  font-size: 0.23rem;
  margin-top: 0.1rem;
}

.game_record {
  width: 90%;
  background: @third-color;
  margin: 0 auto 0.15rem auto;
  //overflow: hidden;
  border-radius: 0.2rem;
  padding: 10px 6px 10px 6px;
  box-sizing: border-box;
  color: @textcolorf;

  display: flex;
  justify-content: flex-start;
}

.other_list {
  width: 84%;
  //background: #303030;
  margin: 0 auto 0.2rem auto;
  //overflow: hidden;
  border-radius: 0.2rem;
  padding: 0.2rem 0.1rem;
  box-sizing: border-box;
  color: @textcolorf;
}

.active_box {
  width: 90%;
  box-sizing: border-box;
  background: @third-color;
  margin: 0 auto 0.2rem auto;
  border-radius: 0.2rem;
  padding: 0.1rem 0.05rem 0;

  .top_title {
    font-size: 12px;
    padding: 4px 0 8px;
    color: @textcolor5;
    text-align: center;
  }

  .active_record {
    color: @textcolorf;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 3px;
  }
}

.language-switcher {
  position: absolute;
  top: 62%;
  right: -2rem;
  width: 2rem;
  background: @secondary-color;
  // height: 2rem;
  padding: 0.2rem;
  box-sizing: border-box;
  border-radius: .2rem;

  .lang {
    color: @popupTextColor;
    text-align: center;
    margin-top: .1rem;
    line-height: 0.6rem;
  }
}

.active-lang {
  color: @textcolor1 !important;
}

.active_item {
  width: 48%;
  margin: 0 2% 6px 0%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0.2rem;
  height: 1.1rem;
  color: @textcolorf;
  font-size: 0.2rem;
  text-indent: 0.1rem;
  line-height: 0.5rem;

  &:nth-child(2n) {
    margin-right: 0;
  }
}

.acbg1 {
  background-image: url("../assets/images/index/bg01.png");
}

.acbg2 {
  background-image: url("../assets/images/index/bg02.png");
}

.acbg3 {
  background-image: url("../assets/images/index/bg03.png");
}

.acbg4 {
  background-image: url("../assets/images/index/bg04.png");
}

.acbg5 {
  background-image: url("../assets/images/index/bg05.png");
}

.acbg6 {
  background-image: url("../assets/images/index/bg06.png");
}

.acbg7 {
  background-image: url("../assets/images/index/bg07.png");
}

.acbg8 {
  background-image: url("../assets/images/index/bg09.jpg");
}

.pro {
  background-image: url("../assets/images/index/bg05.png");
}

.grsvg {
  display: flex;
  align-items: center;
  margin-left: 6px;

  &>svg {
    width: 18px;
    height: 18px;
    color: @popupTextColor;
  }
}

.grsvg img {
  // height: 0.7rem;
}

.van-icon {
  line-height: 0.7rem;
}

.van-icon-list-switch:before {
  font-size: 0.7rem;
  color: @popupTextColor;
}

.grt {
  width: 50%;
  text-align: right;
  padding-left: 0.4rem;
  color: @popupTextColor;
  line-height: 1.5;
}

.left_nav {
  width: 4rem;
  height: 100%;
  background: @secondary-color;
  margin-top: 1.2rem;
  padding-top: 12px;
  position: relative;
  // border-top: 2px solid gold;
}

.bgwrap {
  position: fixed;
  // left: 0;
  top: 0;
  width: @maxWidth;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 5;
  // overflow: hidden;
}

.game_type {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: flex-start;
  justify-content: space-between;
  align-items: center;
}

.game_item.active {
  color: @primary-color;
  background-color: @rechargeColor;
}

.game-itmes {
  padding: 6px 0.2rem 0;
}

.game_item {
  width: 48%;
  /* border-radius: 0.2rem; */
  color: @popupTextColor;
  background-color: @third-color;
  /* height: 1.2rem; */
  border-radius: 0.14rem;
  cursor: pointer;
  font-size: 0.2rem;
  height: 1.19rem;
  /* max-width: 1.3rem; */
  /* min-width: 1.3rem; */
  /* width: 1.3rem; */
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 0.15rem;
}

.game_img {
  // width: 1rem;
  //height: 0.4rem;
  display: block;
  margin: 0 auto;
  // width: 18px;
  height: 18px;
  margin-top: 0.2rem;
}

.mp3_item {
  padding: 0 0.15rem;
  margin-top: .2rem;

  :deep(.audio__btn-wrap) {
    svg {
      color: @rechargeColor;
      fill: @rechargeColor;
    }
  }

  :deep(.audio__play-prev) svg,
  :deep(.audio__play-next) svg {
    width: 12px;
    height: 12px;
  }

  :deep(.audio__play-start) svg {
    width: 16px;
    height: 16px;
  }

  :deep(.audio__play-volume-icon-wrap) {
    display: none;
  }
}

.game_name {
  font-size: 0.25rem;
  overflow: hidden;
  padding: 0 0.04rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  line-height: 0.6rem;
  height: 0.8rem;
  //margin-top: 0.1rem;
}
</style>